// extracted by mini-css-extract-plugin
export default {"inputWrapper":"g8kv8","radio":"LlZOu","body":"AMK4T"};